import React from "react";
import { Modal, Typography, Alert, Divider } from "antd";

import "./LocationAccess.css"; // Custom CSS for styling

const { Text } = Typography;

const LocationAccess = ({ visible, handleClose }) => {
  return (
    <Modal
      className="location-modal"
      title={<div className="modal-title">Location Access Required</div>}
      open={visible}
      footer={null}
      centered
      width={700}
      onCancel={handleClose}
    >
      <div className="modal-content">
        <Alert
          description={
            <>
              <Text className="text-loc-modal">
                Your organization requires location to enhance the security of
                our services. Location data will be used solely for security
                purposes.
              </Text>
              <Divider style={{ margin: "5px" }} />

              <Text className="text-loc-modal">
                Please allow location access from your browser to continue{" "}
                <br />
              </Text>
              {/* <Text strong className="text-loc-modal">Please refresh the page if you're unable to enable location</Text> */}
            </>
          }
          type="info"
          showIcon
        />
      </div>
      <a
        href="/help"
        target="_blank"
        style={{ marginLeft: "10px" }}
        rel="noopener noreferrer"
      >
        Still having trouble?
      </a>
    </Modal>
  );
};

export default LocationAccess;
